import { Auth, Action, ActionTypes } from '../actions';

export default (state: Auth = null, action: Action): Auth => {
  switch (action.type) {
    case ActionTypes.FETCH_USER:
      return action.payload;
    default:
      return state;
  }
};
